import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  icon: {
    height: '28px',
    width: '28px',
    '& *': {
      stroke: `${theme.palette.primary.main} !important`,
    },
  },
  iconDisabled: {
    '& *': {
      stroke: `${theme.palette.grey[300]} !important`,
    },
  },
}));

export default useStyles;
